import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class ItemsReqForCategoryId {
    @ApiProperty()
    @IsNotEmpty({message:"Item Category code should not be empty"})
    itemCategoryId: number;
}

